export default "__VITE_ASSET__f657ee37__"